module.exports = __webpack_public_path__ + "assets/img/ku_icon01.a7fb45bc.png";